import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function PartnersIcon(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none">
			<path opacity="0.5" d="M14.4651 4.20245C15.7203 3.46072 17.2797 3.46073 18.5349 4.20245L20.0349 5.08882C21.2528 5.80848 22 7.1179 22 8.53252V9.5V10.4675C22 11.8821 21.2528 13.1915 20.0349 13.9112L18.5349 14.7975C17.2797 15.5393 15.7203 15.5393 14.4651 14.7976L12.9651 13.9112C11.7472 13.1915 11 11.8821 11 10.4675V9.5V8.53252C11 7.1179 11.7472 5.80848 12.9651 5.08881L14.4651 4.20245Z" fill={props.fill}/>
			<path d="M7.46509 16.2024C8.72031 15.4607 10.2797 15.4607 11.5349 16.2025L13.0349 17.0888C14.2528 17.8085 15 19.1179 15 20.5325V21.5V22.4675C15 23.8821 14.2528 25.1915 13.0349 25.9112L11.5349 26.7975C10.2797 27.5393 8.72031 27.5393 7.46509 26.7976L5.96508 25.9112C4.74719 25.1915 4 23.8821 4 22.4675V21.5V20.5325C4 19.1179 4.74719 17.8085 5.96508 17.0888L7.46509 16.2024Z" fill={props.fill}/>
			<path d="M21.4651 16.2024C22.7203 15.4607 24.2797 15.4607 25.5349 16.2025L27.0349 17.0888C28.2528 17.8085 29 19.1179 29 20.5325V21.5V22.4675C29 23.8821 28.2528 25.1915 27.0349 25.9112L25.5349 26.7975C24.2797 27.5393 22.7203 27.5393 21.4651 26.7976L19.9651 25.9112C18.7472 25.1915 18 23.8821 18 22.4675V21.5V20.5325C18 19.1179 18.7472 17.8085 19.9651 17.0888L21.4651 16.2024Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<PartnersIcon fill={props.fill} />
		</div>
	);
}